import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { buildUrl, fetchWithAccessToken } from '../services/HttpService';
import { navigate } from "../utils/navigation";
import { logException } from '../services/LoggingService'
import ZeroStateSourcingProjects from '../components/telescope/ZeroStateSourcingProjects';
import ZeroStateOpportunityProjects from '../components/telescope/ZeroStateOpportunityProjects';

const styles = {
  container: {
    textAlign: 'center',
    marginTop: '5%',
    background: 'linear-gradient(90deg, rgba(83,108,48,1) 0%, rgba(45,46,70,1) 25%, rgba(45,46,70,1) 100%)',
    color: 'white',
    padding: '20px',
    borderRadius: '10px',
  },
  colorwhite: {
    color: 'white',
  },
};

const TestView = ({ message }) => {

  const [showZeroState, setShowZeroState] = useState(null);

  const handleIntentionalError = () => {

    try {

      throw new Error("Intentional 500 error triggered.");

    } catch (error) {
      // You can also log the error to an external service here if needed.
      logException(error);
    }

  }

  const handleIntentional500 = () => {
    throw new Error("Intentional 500 error triggered.");
  }

  const handleIntentional404 = () => {
    navigate("/ThisPageDoesNotExist");
  }

  const handleHealth = () => {
    navigate("/health");
  }

  const handleIconSamples = () => {
    navigate("/test/icons");
  }

  const handleGeolocationExample = () => {
    navigate("/test/geo");
  }

  const handleMapExample = () => {
    navigate("/test/map");
  }

  const handleSupplierScoreExample = () => {
    navigate("/test/supplierscore");
  }

  const handleOpenSearchTesting = () => {
    navigate("/test/api-endpoint");
  }

  const handleSupplierSearchOpenSearchTesting = () => {
    navigate("/suppliers/search?endpoint=opensearch");
  }

  const handleSupplierSearchOpenSearchV1Testing = () => {
    navigate("/suppliers/search?endpoint=opensearch-v1");
  }

  const handleSupplierSearchVectorTesting = () => {
    navigate("/suppliers/search?endpoint=vector");
  }

  const handleSupplierToItemTest = () => {
    navigate("/test/supplier-to-item");
  }

  const handleSupplierRequirementsTest = () => {
    navigate("/test/supplier-requirements");
  }

  const handleShowSourcingZeroState = () => {
    setShowZeroState(showZeroState === 'sourcing' ? null : 'sourcing');
  }

  const handleShowOpportunityZeroState = () => {
    setShowZeroState(showZeroState === 'opportunity' ? null : 'opportunity');
  }

  const handleDocumentManagerTest = () => {
    navigate("/test/documents");
  }

  const intentional401 = async () => {
    console.error("Intentional 401 Unauthorized error triggered.");

    const url = buildUrl("test/error401");
    const response = await fetchWithAccessToken(url);

    if (response.ok){
      const data = await response.json();
      console.log("Response from intentional 401 Unauthorized error:", data);
      if (response.status === 401) {
        console.error("401 Unauthorized - error");
      } else {
        console.log("Response data:", data);
      }
  
    }
  }
  
  const intentional403 = async () => {
    console.error("Intentional 403 Forbidden error triggered.");

    const url = buildUrl("test/error403");
    const response = await fetchWithAccessToken(url);

    if (response.ok){
      const data = await response.json();
      console.log("Response from intentional 403 Forbidden error:", data);
      if (response.status === 403) {
        console.error("403 Forbidden - error");
      } else {
        console.log("Response data:", data);
      }  
    }
  }
  
  const intentional405 = async () => {
    console.error("Intentional 405 Method Not Allowed error triggered.");

    const url = buildUrl("test/error405");
    const response = await fetchWithAccessToken(url);

    if (response.ok){
      const data = await response.json();
      console.log("Response from intentional 405 Method Not Allowed error:", data);
      if (response.status === 405) {
        console.error("Unauthorized access - 405 Method Not Allowed error");
      } else {
        console.log("Response data:", data);
      }  
    }
  }
  
  const intentional409 = async () => {
    console.error("Intentional 409 error triggered.");

    const url = buildUrl("test/error409");
    const response = await fetchWithAccessToken(url);

    if (response.ok){
      const data = await response.json();
      console.log("Response from intentional 409 Conflict error:", data);
      if (response.status === 401) {
        console.error("409 Conflict - error");
      } else {
        console.log("Response data:", data);
      }  
    }
  }
  
  const intentional422 = async () => {
    console.error("Intentional 422 Unprocessable Content error triggered.");

    const url = buildUrl("test/error422");
    const response = await fetchWithAccessToken(url);

    if (response.ok){
      const data = await response.json();
      console.log("Response from intentional 422 Unprocessable Content error:", data);
      if (response.status === 422) {
        console.error("422 Unprocessable Content - error");
      } else {
        console.log("Response data:", data);
      }  
    }
  }
  
  const intentional500 = async () => {
    console.error("Intentional 500 Internal Server Error triggered.");

    const url = buildUrl("test/error500");
    const response = await fetchWithAccessToken(url);

    if (response.ok){
      const data = await response.json();
      console.log("Response from intentional 500 Internal Server Error:", data);
      if (response.status === 500) {
        console.error("SERVER ERROR - 500 error");
      } else {
        console.log("Response data:", data);
      }  
    }
  }
  
  return (
    <>
      <Row>
        <Col lg={3}>
        </Col>
        <Col lg={6}>
          <div style={styles.container}>
            <h3 style={styles.colorwhite}>{message}</h3>
            <br />
            <h2 style={styles.colorwhite}>Testing Page</h2>
          </div>

        </Col>
      </Row>
      <Row>

        <Col lg={3}>
        </Col>

        <Col lg={6}>

          <br />
          <h2>Telescope App Testing</h2>

          <br />
          <button className="btn btn-secondary" onClick={handleHealth}>
            PING
          </button>
          &nbsp;
          (Health Check / System Status)
          <br /><br />
          <hr />
          <h4>Documents</h4>
          <button className="btn btn-secondary" onClick={handleDocumentManagerTest}>
            Document Manager testing
          </button>

          <br/><br/>
          <hr />
          <h4>Supplier Search</h4>
          API endpoint setting: &nbsp;
          <br/>
          <button className="btn btn-secondary" onClick={handleOpenSearchTesting}>
            OPENSEARCH V2 &nbsp;|&nbsp; OPENSEARCH V1 &nbsp;|&nbsp; VECTOR 
          </button>
          &nbsp;
          <br/>
          <br/>
          Force API endpoint on Supplier Search page: &nbsp;
          <br/>
          <button className="btn btn-secondary" onClick={handleSupplierSearchOpenSearchTesting}>
            <strong>(OPENSEARCH V2)</strong> Supplier Search
          </button>
          &nbsp;
          <button className="btn btn-secondary" onClick={handleSupplierSearchOpenSearchV1Testing}>
            <strong>(OPENSEARCH V1)</strong> Supplier Search
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  TESTING DEPLOY 
          <button className="btn btn-secondary" onClick={handleSupplierSearchVectorTesting}>
            <strong>(VECTOR)</strong> Supplier Search 
          </button>
          &nbsp;

          <br /><br />
          <hr />
          <h4>Supplier Requirements & Scoring</h4>
          <button className="btn btn-secondary" onClick={handleSupplierRequirementsTest}>
            Supplier Requirements testing
          </button>
          &nbsp;
          <br/><br/>
          <button className="btn btn-secondary" onClick={handleSupplierScoreExample}>
            Supplier Score Calculator
          </button>

          &nbsp;
          <br/><br/>
          <button className="btn btn-secondary" onClick={handleSupplierToItemTest}>
            Supplier-to-Item Association testing
          </button>

          <br /><br />
          <hr />
          <h4>Geolocation & Mapping</h4>
          <button className="btn btn-secondary" onClick={handleGeolocationExample}>
            Geolocation example 
          </button>
          &nbsp;
          <button className="btn btn-secondary" onClick={handleMapExample}>
            Map Leaflet example 
          </button>

          <br /><br />
          <hr />
          <h4>UI / UX</h4>
          <button className="btn btn-secondary" onClick={handleIconSamples}>
            ICON samples (Telescope Icons)
          </button>
          &nbsp;
          <button className="btn btn-secondary" onClick={handleShowSourcingZeroState}>
            EXAMPLE: ZERO STATE - Sourcing Projects
          </button>
          &nbsp;
          <button className="btn btn-secondary" onClick={handleShowOpportunityZeroState}>
            EXAMPLE: ZERO STATE - Opportunity Projects
          </button>

          {/* Conditional rendering of ZeroState components */}
          {showZeroState === 'sourcing' && (
            <div className="mt-4 p-3 border rounded">
              <ZeroStateSourcingProjects />
            </div>
          )}
          {showZeroState === 'opportunity' && (
            <div className="mt-4 p-3 border rounded">
              <ZeroStateOpportunityProjects />
            </div>
          )}

        </Col>
        <Col lg={3}></Col>

      </Row>

      
      

      <Row>

        <Col lg={3}>
        </Col>

        <Col lg={3}>
          <br /><br />
          <h2>Intentional Error Testing</h2>
        </Col>
      </Row>
      <Row>

        <Col lg={3}>
        </Col>

        <Col lg={3}>

          <br />
          <h5>
            REACT-TELESCOPE 
            &nbsp;
            <br />
            <small>(front-end) Error Testing</small>
          </h5>

          <br />
  
          <button className="btn btn-danger" onClick={handleIntentional404}>
            Trigger 404 Error
          </button>

          <br /><br />
          <button className="btn btn-danger" onClick={handleIntentional500}>
            Trigger 500 Error
          </button>

          <br /><br />
          <button className="btn btn-danger" onClick={handleIntentionalError}>
            Trigger Error, Catch and Log 
          </button>

        </Col>
        <Col lg={3}>

          <br />
          <h5>
            DataAPI  
            &nbsp;
            <br />
            <small>(middle tier) Error Testing</small>
          </h5>

          <br />
          <button className="btn btn-danger" onClick={intentional401}>
            Trigger 401 Error (@ DataAPI)
          </button>

          <br /><br />
          <button className="btn btn-danger" onClick={intentional403}>
            Trigger 403 Error (@ DataAPI)
          </button>

          <br /><br />
          <button className="btn btn-danger" onClick={intentional405}>
            Trigger 405 Error (@ DataAPI)
          </button>

          <br /><br />
          <button className="btn btn-danger" onClick={intentional409}>
            Trigger 409 Error (@ DataAPI)
          </button>

          <br /><br />
          <button className="btn btn-danger" onClick={intentional422}>
            Trigger 422 Error (@ DataAPI)
          </button>

          <br /><br />
          <button className="btn btn-danger" onClick={intentional500}>
            Trigger 500 Error (@ DataAPI)
          </button>

        </Col>
      </Row>
    </>

  );
};

TestView.propTypes = {
  message: PropTypes.string,
};


TestView.defaultProps = {
  message: 'XXX -- Feature not available',
};

export default TestView;